module.exports = __webpack_public_path__ + "static/assets/a7206ec49a3fb9b19a4067296f879553.png";